import { List, Create } from "../Components/index.js";

export default [
    {
        path: "/letter/comments",
        component: List,
        name: "letter.comments",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/comments/create",
        component: Create,
        name: "letter.comments.create",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/letter/comments/:id/view', component: archiveLetterDetails, name: 'letter.comments.view'},
];
